import React from 'react'
import { shallow } from 'enzyme'

import File from '../../features/TextEditor/File'

describe('File', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      filename: 'test.pdf',
      link: 'http://www.google.com/test.pdf',
      hideClose: false,
      published: true,
      isUploading: false,
      onFileDeleteClick: jest.fn(),
    },
    wrapper = shallow(<File {...props} />)
    instance = wrapper.instance()
  })
  it('should have Background published as true', () => {
    const background = wrapper.find('File__Background').at(0)
    expect(background).toHaveLength(1)
    expect(background.prop('published')).toBeTruthy()
  })
  it('should have FileUploadedIcon states', () => {
    const fileIcon = wrapper.find('File__FileUploadedIcon').at(0)
    expect(fileIcon).toHaveLength(1)
  })
  describe('#onFileDeleteClick', () => {
    it('should call props method', () => {
      instance.onFileDeleteClick()
      expect(props.onFileDeleteClick).toHaveBeenCalled();
    })
  })
})